<div>
  <ng-container *ngIf="isMobile">
    <div (click)="goToLogin()" class="arrow-left">
      <img src="assets/image/arrow-left.svg" />
    </div>
  </ng-container>

  <ng-container *ngIf="!isMobile">
    <div class="desc">
      <div class="mt-5 text-center">
        <img src="assets/image/merchants/{{ merchant }}/logo-login-blue.svg" />
      </div>
      <div class="text-login mt-3 text-center">
        <h1>
          {{
            tenant === tenantService.XP_NAME
              ? "Plataforma OZ"
              : "Plataforma de câmbio"
          }}
        </h1>
        <div class="mt-5 mb-5 text-center">
          <img src="assets/image/circles.svg" alt="Logo Oz Câmbio" />
        </div>
      </div>
    </div>
  </ng-container>

  <div class="container-login">
    <div class="text-login mt-5">
      <h4>Recuperação de senha</h4>
      <p class="mt-3">
        Digite seu e-mail cadastrado para receber um link e criar uma nova senha
        de acesso.
      </p>
    </div>
    <form [formGroup]="resetPassForm" class="mt-3">
      <div>
        <mat-form-field appearance="outline">
          <mat-label>E-mail</mat-label>
          <input matInput formControlName="email" type="text" />
          <mat-error
            class="mb-1"
            *ngIf="
              resetPassControl.email.touched &&
              resetPassControl.email.errors?.required
            "
          >
            E-mail obrigatório
          </mat-error>
        </mat-form-field>
      </div>
      <div class="mt-3">
        <button
          class="btn btn-block mt-3"
          type="button"
          [ngClass]="{
            'btn-disabled': resetPassForm.invalid,
            'btn-dark-blue': !resetPassForm.invalid
          }"
          (click)="sendResetEmail()"
          [disabled]="resetPassForm.invalid"
        >
          Enviar
          <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
        </button>
      </div>
    </form>
    <div class="create-account text-center">
      <p class="mt-4">
        Não tem conta?
        <a routerLink="{{ '/' + tenant + '/person-type' }}">Crie sua conta.</a>
      </p>
    </div>

    <ng-container *ngIf="isMobile">
      <div class="text-center mt-5 lg-bottom">
        <img
          class="logo-oz"
          src="../../../../assets/image/merchants/{{
            merchant
          }}/oz-white-logo.svg"
          alt="logo"
        />
      </div>
    </ng-container>
  </div>
</div>
